import { useQuery } from '@tanstack/react-query'
import { settingsService } from 'v2/shared/services/settings-service'
import { getSettingsQueryKeys } from 'v2/shared/utils/query-key-management'

interface SipEndpoint {
  username: string
  password: string
}

// SER-5347: SIP creds are normally provisioned at login and shipped in the
// profile. If they are missing (provisioning gap), fetch-or-generate them
// on demand via GET /accounts/sip-credentials instead of leaving the phone
// SDK uninitialized.
export const useSipEndpoint = (
  profileEndpoint: SipEndpoint | undefined,
  profileLoaded: boolean,
): SipEndpoint | undefined => {
  const hasProfileCreds = Boolean(profileEndpoint?.username && profileEndpoint?.password)
  const { data } = useQuery({
    queryKey: getSettingsQueryKeys().sipCredentials,
    enabled: profileLoaded && !hasProfileCreds,
    queryFn: async () => {
      const response = await settingsService.getSipCredentials()
      return response.data.sip_endpoint
    },
  })
  return hasProfileCreds ? profileEndpoint : data
}
